import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  activeInactiveStatus,
  activeInactiveStatusNumeric,
  all_account_types,
  popularities,
  randomCountUpto100,
  testimonialCategories,
  whatsapp_verification,
} from "../common-data/DropdowData";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";
import { fetchMealTimesData } from "../../redux/reducers/dropdownApiSlice";
import { selectToken } from "../auth/auth.selector";
import {
  fetchCustomerIntentData,
  fetchDietPreferenceData,
  fetchDietTypesData,
} from "../../redux/reducers/apiSlice";
import MultiSelect from "../components-react/MultiSelect";
import {
  fetchBlogCategoriesData,
  fetchParentBlogCategoriesData,
} from "../../redux/ad-blog-reducers/blogSlice";
import { fetchDashboardMenusdata } from "../../redux/dashboard-features/featuresSlice";

const SearchNButtons = (props) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const { mealTimes } = useSelector((state) => state.dropdown);
  const { dietTypesData, dietPreferenceData, customerIntentCategory } =
    useSelector((state) => state.api);
  const {
    blogCategories,
    blogsLoading,
    parentBlogCategories,
    parentBlogCategoriesLoading,
  } = useSelector((state) => state.blog);
  const { dashboardMenus, dashboardMenusLoading } = useSelector(
    (state) => state.features
  );

  const [mealCategories, setMealCategories] = useState([]);
  const iniDrpdownData = {
    allDietPreferences: [],
    allBodyTypes: [],
    allUsers: [],
  };
  const [allDPDropdownData, setAllDPDropdownData] = useState(iniDrpdownData);
  const [customerIntents, setCustomerIntents] = useState([]);
  const [allBlogParentCategories, setAllBlogParentCategories] = useState([]);
  const [allBlogCategories, setAllBlogCategories] = useState([]);
  const [allMenus, setAllMenus] = useState([]);

  const {
    pageName,
    pageName1,
    btnText,
    searchFilterApplied,
    filters,
    setFilters,
    onClickSearch,
    onClickAdd,
    search,
    setSearch,
    handleKeyPress,
    userInfoData,
  } = props || {};

  function getDietPreference() {
    dispatch(
      fetchDietPreferenceData({
        pageNo: 1,
        limit: 10,
        queryParameters: "&status=active",
        token: token,
      })
    );
  }

  function getDietTypes() {
    dispatch(
      fetchDietTypesData({
        pageNo: 1,
        limit: 10,
        queryParameters: "&status=active",
        token: token,
      })
    );
  }

  function getCustomerIntent(filters) {
    dispatch(
      fetchCustomerIntentData({
        filters: filters,
        token: token,
      })
    );
  }

  function getBlogCategories() {
    const filters = {
      page: 1,
      limit: 1000,
    };

    dispatch(
      fetchBlogCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getParentBlogCategories() {
    const filters = {
      page: 1,
      limit: 1000,
    };

    dispatch(
      fetchParentBlogCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getDashboardMenus() {
    const filters = {
      page: 1,
      limit: 1000,
      status: 1,
    };

    dispatch(
      fetchDashboardMenusdata({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (
      pageName !== "fitness_profile" &&
      pageName !== "workout-goal" &&
      pageName !== "testimonial"
    ) {
      dispatch(
        fetchMealTimesData({
          token: token,
          qps: "",
          pageNo: 1,
          limit: 1000,
        })
      );
    }

    if (pageName === "followup") {
      const filtersToSend = {
        page: 1,
        limit: 10,
        status: "active",
      };

      getCustomerIntent(filtersToSend);
    }

    if (pageName === "blogs") {
      getBlogCategories();
    }

    if (pageName1 === "blog_sub_categories") {
      getParentBlogCategories();
    }

    if (pageName === "dash-features") {
      getDashboardMenus();
    }
  }, []);

  useEffect(() => {
    if (mealTimes) {
      setMealCategories(mealTimes);
    } else {
      setMealCategories([]);
    }
  }, [mealTimes]);

  useEffect(() => {
    if (pageName === "dp") {
      getDietPreference();
      getDietTypes();
    }
  }, []);

  useEffect(() => {
    if (pageName === "dp") {
      if (dietPreferenceData?.status && dietPreferenceData?.data?.length > 0) {
        const { data } = dietPreferenceData || {};
        const allDPs = data?.map((dp) => ({
          label: dp?.value,
          value: dp?.uid,
        }));
        setAllDPDropdownData((prevs) => ({
          ...prevs,
          allDietPreferences: allDPs,
        }));
      } else {
        setAllDPDropdownData((prevs) => ({
          ...prevs,
          allDietPreferences: [],
        }));
      }
    }
  }, [dietPreferenceData]);

  useEffect(() => {
    if (pageName === "dp") {
      if (dietTypesData?.status && dietTypesData?.data?.length > 0) {
        const { data } = dietTypesData || {};
        const allDPs = data?.map((dp) => ({
          label: dp?.value,
          value: dp?.uid,
        }));
        setAllDPDropdownData((prevs) => ({
          ...prevs,
          allBodyTypes: allDPs,
        }));
      } else {
        setAllDPDropdownData((prevs) => ({
          ...prevs,
          allBodyTypes: [],
        }));
      }
    }
  }, [dietTypesData]);

  useEffect(() => {
    if (pageName === "followup") {
      if (
        customerIntentCategory?.status &&
        customerIntentCategory?.data?.length > 0
      ) {
        const allIntents = customerIntentCategory?.data?.map((item) => ({
          value: item?.uid || "",
          label: item?.name || "",
        }));

        setCustomerIntents(allIntents);
      } else {
        setCustomerIntents([]);
      }
    }
  }, [customerIntentCategory]);

  useEffect(() => {
    if (
      pageName === "blogs" &&
      blogCategories?.status &&
      blogCategories?.data?.length > 0
    ) {
      const allBlogs = blogCategories.data?.map((blog) => {
        return { label: blog?.name, value: blog?.uid, info: blog };
      });

      setAllBlogCategories(allBlogs);
    } else {
      setAllBlogCategories([]);
    }
  }, [blogCategories]);

  useEffect(() => {
    if (
      pageName1 === "blog_sub_categories" &&
      parentBlogCategories?.status &&
      parentBlogCategories?.data?.length > 0
    ) {
      const allBlogs = parentBlogCategories.data?.map((blog) => {
        return { label: blog?.name, value: blog?.uid, info: blog };
      });

      setAllBlogParentCategories(allBlogs);
    } else {
      setAllBlogParentCategories([]);
    }
  }, [parentBlogCategories]);

  useEffect(() => {
    if (
      pageName === "dash-features" &&
      dashboardMenus?.status &&
      dashboardMenus?.data?.length > 0
    ) {
      const allmenus = dashboardMenus.data?.map((blog) => {
        return { label: blog?.menu_name, value: blog?.menu_id, info: blog };
      });

      setAllMenus(allmenus);
    } else {
      setAllMenus([]);
    }
  }, [dashboardMenus]);

  return (
    <div className="spaceBetweeenContainer">
      <div className="spaceBetChild firstChild">
        <div
          className={`inputCommonWrapper flexSpacebetween searchBarContainer ${
            searchFilterApplied ? "redBorderRedText" : ""
          }`}
        >
          <input
            type="search"
            className="input"
            placeholder="Search..."
            value={filters ? filters?.searchString : search ? search : ""}
            onChange={(e) =>
              setFilters
                ? setFilters({
                    ...filters,
                    searchString: e.target.value,
                  })
                : setSearch(e.target.value)
            }
            onKeyDown={handleKeyPress}
          />
          <button type="button" className="button" onClick={onClickSearch}>
            search
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-search"
              viewBox="0 0 16 16"
            >
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
            </svg>
          </button>
        </div>

        <div className="filtersDropdowns">
          {pageName === "meal" && (
            <>
              <div
                className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                  filters?.category?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdownLabel
                  options={mealCategories}
                  selectedOption={filters?.category}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      category: selectedValue,
                    })
                  }
                  name="Category"
                />
              </div>

              <div
                className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                  filters?.isPopular?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdownLabel
                  options={popularities}
                  selectedOption={filters?.isPopular}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      isPopular: selectedValue,
                    })
                  }
                  name="Popularity"
                />
              </div>
            </>
          )}

          {(pageName === "meal" ||
            pageName === "workout-goal" ||
            pageName === "testimonial" ||
            pageName === "dp" ||
            pageName === "workout-cats" ||
            pageName === "followup" ||
            pageName === "intents" ||
            pageName === "blog_categories" ||
            pageName === "blogs" ||
            pageName === "dash-features" ||
            pageName === "dash-feature-grouping" ||
            pageName === "hygiene-task-categories") && (
            <div
              className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                filters?.isActive?.value && "redBorderRedText"
              }`}
            >
              <SelectDropdownLabel
                options={
                  pageName === "blog_categories" ||
                  pageName === "blogs" ||
                  pageName === "dash-features"
                    ? activeInactiveStatusNumeric
                    : activeInactiveStatus
                }
                selectedOption={filters?.isActive}
                setSelectedOption={(selectedValue) =>
                  setFilters({
                    ...filters,
                    isActive: selectedValue,
                  })
                }
                name="Status"
              />
            </div>
          )}

          {pageName === "dp" && (
            <>
              <div
                className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                  filters?.selectedBodyType?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdownLabel
                  options={allDPDropdownData.allBodyTypes}
                  selectedOption={filters?.selectedBodyType}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedBodyType: selectedValue,
                    })
                  }
                  name="Diet Type"
                />
              </div>

              <div
                className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                  filters?.selectedDietPreference?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdownLabel
                  options={allDPDropdownData.allDietPreferences}
                  selectedOption={filters?.selectedDietPreference}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedDietPreference: selectedValue,
                    })
                  }
                  name="Diet Preferences"
                />
              </div>
            </>
          )}

          {pageName === "testimonial" && (
            <>
              <div
                className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                  filters?.selCategory?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdownLabel
                  options={testimonialCategories}
                  selectedOption={filters?.selCategory}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selCategory: selectedValue,
                    })
                  }
                  name="Category"
                />
              </div>
            </>
          )}

          {pageName === "followup" && (
            <>
              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selCustomerIntent?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdownLabel
                  options={customerIntents}
                  selectedOption={filters?.selCustomerIntent}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selCustomerIntent: selectedValue,
                    })
                  }
                  name="Customer Intent"
                  preventKeyboardOpen={true}
                />
              </div>

              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selectedWhatsappVerification?.value
                    ? "redBorderRedText"
                    : ""
                }`}
              >
                <SelectDropdownLabel
                  options={whatsapp_verification}
                  selectedOption={filters?.selectedWhatsappVerification}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedWhatsappVerification: selectedValue,
                    })
                  }
                  name="WP Verification"
                  preventKeyboardOpen={true}
                />
              </div>
            </>
          )}

          {pageName1 === "blog_sub_categories" && (
            <div
              className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                filters?.selectedParentCategory?.value && "redBorderRedText"
              }`}
            >
              <SelectDropdownLabel
                options={allBlogParentCategories}
                selectedOption={filters?.selectedParentCategory}
                setSelectedOption={(selectedValue) =>
                  setFilters({
                    ...filters,
                    selectedParentCategory: selectedValue,
                  })
                }
                name="Parent Category"
                isDisable={parentBlogCategoriesLoading}
              />
            </div>
          )}

          {pageName === "blogs" && (
            <div
              className={`commonWrapper dropdownCommonWrapper multiselect-filter ${
                filters?.selectedBlogCategories?.length > 0
                  ? "redBorderRedText"
                  : ""
              }`}
            >
              <MultiSelect
                options={allBlogCategories}
                state={filters?.selectedBlogCategories}
                setState={(selectedValue) =>
                  setFilters({
                    ...filters,
                    selectedBlogCategories: selectedValue,
                  })
                }
                name="Blog Categories"
                isDisable={blogsLoading}
              />
            </div>
          )}

          {pageName === "dash-features" && (
            <>
              <div
                className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                  filters?.selectedSequence?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdownLabel
                  options={randomCountUpto100}
                  selectedOption={filters?.selectedSequence}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedSequence: selectedValue,
                    })
                  }
                  name="Sequence"
                />
              </div>

              <div
                className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
                  filters?.selectedMenus?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdownLabel
                  options={allMenus}
                  selectedOption={filters?.selectedMenus}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedMenus: selectedValue,
                    })
                  }
                  name="menu"
                  isDisable={dashboardMenusLoading}
                />
              </div>
            </>
          )}

          {pageName === "dash-feature-grouping" && (
            <div
              className={`commonWrapper dropdownCommonWrapper ${
                filters?.selectedAccountType?.value && "redBorderRedText"
              }`}
            >
              <SelectDropdownLabel
                options={all_account_types}
                selectedOption={filters?.selectedAccountType}
                setSelectedOption={(selectedValue) =>
                  setFilters({
                    ...filters,
                    selectedAccountType: selectedValue,
                  })
                }
                name="Role"
              />
            </div>
          )}
        </div>
      </div>

      {btnText && (
        <div className="spaceBetChild secChild">
          <button type="button" className="btn btn-danger" onClick={onClickAdd}>
            {btnText}
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchNButtons;
